import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';

let prefixesUsed = [];

/**
 * Constructs an enumeration with values equal to a prefix + key.
 *
 * For example:
 *   var COLORS = constructActionTypes({blue: null, red: null}, "prefix");
 *   COLORS.blue == 'prefix/blue';
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: `${prefix}/${key1}`, key2: `${prefix}/${key2}`}
 *
 * @param {object} obj
 * @param {string} prefix
 * @return {object}
 */
export default (obj, prefix) => {
    if (!isObject(obj) || isArray(obj)) {
        throw new Error('constructActionTypes(...): First argument must be an object.');
    }
    if (!isString(prefix)) {
        throw new Error('constructActionTypes(...): Second argument must be an string.');
    }
    if (prefixesUsed.indexOf(prefix) !== -1) {
        throw new Error('Trying to construct ActionTypes with the same prefix');
    }
    prefixesUsed.push(prefix);

    return Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            [key]: `${prefix}/${key}`,
        }),
        {},
    );
};

export const _clearPrefixesUsed = () => (prefixesUsed = []);
